export default "__VITE_ASSET__BeA7Pt9t__"